























/* eslint-disable vue/prop-name-casing */
import { defineComponent } from '@nuxtjs/composition-api';
import { BaseCarouselItem } from '@shared/ui';

import CarouselSection from '~/components/CarouselSection/CarouselSection.vue';
import Container from '~/components/Container.vue';
import ContentCard from '~/components/ContentCard/ContentCard.vue';

export default defineComponent({
  name: 'ContentCards',
  components: {
    BaseCarouselItem,
    CarouselSection,
    ContentCard,
    Container,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: [Object, String],
      default: () => ({}),
    },
    link_text: {
      type: String,
      default: '',
    },
    contents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasContents(): boolean {
      return this.contents.length > 0;
    },
    linkText(): string {
      return this.link_text ? this.link_text : 'See all';
    },
  },
});
